import config from '../request/config';
import { TOKEN_KEY } from '../request/request';

// web2 hands off with https://coin.../?token=xxx (or #/...?token=xxx).
// Store it, then strip it from the address bar.
export function captureToken() {
  const search = new URLSearchParams(window.location.search);
  const hashQuery = window.location.hash.split('?')[1] || '';
  const token = search.get('token') || new URLSearchParams(hashQuery).get('token');
  if (!token) return;

  localStorage.setItem(TOKEN_KEY, token);
  search.delete('token');
  const qs = search.toString();
  const hash = window.location.hash.split('?')[0];
  window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + hash);
}

export default (to, from, next) => {
  if (localStorage.getItem(TOKEN_KEY)) {
    next();
  } else {
    window.location.href = config.memberUrl;
  }
};
